import chatDispatcher from 'common/components/chat/data/dispatcher'
import conversationStore from 'common/components/chat/data/conversation_store/conversationStore'
import assign from 'object-assign'
import { EventEmitter } from 'events'
import coreUtils from 'common/src/utils/coreUtils'

const CHANGE_EVENT = 'change'
const ACCEPT = { 'Accept': 'application/vnd.api+json; version=3' }
let messages = []
let currentOpenConversationID = null
let loading = true
let links = null
let allMessagesLoaded = false
let scrollingMessages = false
let unreadMessageCount = 0

const messageStore = assign({}, EventEmitter.prototype, {
  getAll: function () {
    return [...messages]
  },

  getLoading: function () {
    return loading
  },

  allMessagesLoaded: function () {
    return allMessagesLoaded
  },

  unreadMessageCount: function () {
    return unreadMessageCount
  },

  scrollingMessages: function () {
    return scrollingMessages
  },

  fetchNext: function () {
    if (!links.next) return
    $.ajax({
      url: links.next,
      method: 'GET',
      headers: ACCEPT,
    }).done((response) => {
      chatDispatcher.dispatch({ type: 'MESSAGES_FETCH_NEXT_SUCCESS', data: response })
    })
  },

  getAllForConversation: function (conversationID, messageUrl) {
    $.ajax({
      url: messageUrl,
      data: { 'page[size]': 50 },
      method: 'GET',
      headers: ACCEPT,
    }).done((response) => {
      chatDispatcher.dispatch({ type: 'MESSAGES_FETCH_SUCCESS', data: response })
    })
  },

  getAllForCurrentConversation: function () {
    allMessagesLoaded = false
    scrollingMessages = false
    const currentConversation = conversationStore.getCurrent()
    if (!currentConversation) return
    return this.getAllForConversation(currentConversation.id, threadUrl(currentConversation))
  },

  emitChange: function () {
    console.log('emit change from messages')
    this.emit(CHANGE_EVENT)
  },

  addChangeListener: function (callback) {
    this.on(CHANGE_EVENT, callback)
  },

  removeChangeListener: function (callback) {
    this.removeListener(CHANGE_EVENT, callback)
  }
})

function threadUrl(conversation) {
  const jobId = conversation.relationships.job.data.id

  if (conversationStore.getPageContextType() === 'user') {
    return `${window.App.url}/messages/job/${jobId}/business/${conversation.relationships.business.data.id}`
  }

  return `${window.App.url}/messages/job/${jobId}`
}

function readUrl(message) {
  return `${window.App.url}/messages/${message.id}/read`
}

function appendMessage(message) {
  messages.push(message)
}

function replaceMessage({ id, replacementMessage }) {
  messages = messages.map((m) => (m.id === id ? replacementMessage : m))
}

function buildOptimisticMessage({ messageBody = '', error = false, spinner = false }) {
  return {
    id: `FAKE_${Math.round(Math.random() * 10000)}_ID`,
    attributes: { body: messageBody, author: true, error, loading: spinner, file: [] }
  }
}

function createMessage({ data, contentType = 'application/vnd.api+json', optimisticMessage }) {
  appendMessage(optimisticMessage)
  $.ajax({
    url: window.App.url + '/messages',
    data,
    method: 'POST',
    headers: ACCEPT,
    processData: false,
    contentType
  }).done((response) => {
    chatDispatcher.dispatch({
      type: 'MESSAGE_POST_SUCCESS',
      data: response.data,
      optimisticMessageID: optimisticMessage.id
    })
  }).fail((response) => {
    const errorMessageText = response.status === 500
      ? 'There was an error posting your message.'
      : response.responseJSON.errors[0].detail
    chatDispatcher.dispatch({
      type: 'MESSAGE_POST_FAIL',
      response,
      optimisticMessageID: optimisticMessage.id,
      errorMessageText
    })
  })
}

function dataBuilder(messageBody, aiGenerated = false) {
  const currentConversation = conversationStore.getCurrent()
  const jobData = currentConversation.relationships.job.data
  const pageContextType = conversationStore.getPageContextType()
  const sender = pageContextType === 'user' ? currentConversation.relationships.user.data : currentConversation.relationships.business.data
  const recipient = pageContextType === 'user' ? currentConversation.relationships.business.data : currentConversation.relationships.user.data

  return (
    JSON.stringify(
      {
        "data": {
          "type": "messages",
          "attributes": {
            "body": messageBody,
            "ai_generated": aiGenerated
          },
          "relationships": {
            "job": {
              "data": jobData
            },
            "sender": {
              "data": sender
            },
            "recipient": {
              "data": recipient
            }
          }
        },
        "included": [
          {
            "type": "message-source",
            "attributes": {
              "source": coreUtils.mobilecheck() ? 'mobile' : 'desktop',
              "user-agent": coreUtils.userAgent()
            }
          }
        ]
      }
    )
  )
}

function markAllAsRead() {
  if (window.App && window.App.isCloakingUser) return

  const unread = messages.find(m => m.attributes.author === false && m.attributes.read === false)
  if (unread) {
    $.ajax({
      url: readUrl(unread),
      method: 'PATCH',
      headers: { ...ACCEPT, 'Content-Type': 'application/vnd.api+json' }
    }).done((response) => {
      chatDispatcher.dispatch({ type: 'MARK_ALL_AS_READ_SUCCESS', data: response })
    })
  }
}

function markAsRead(message) {
  if (window.App && window.App.isCloakingUser) return

  $.ajax({
    url: readUrl(message),
    method: 'PATCH',
    headers: { ...ACCEPT, 'Content-Type': 'application/vnd.api+json' }
  }).done((response) => {
    chatDispatcher.dispatch({ type: 'MARK_AS_READ_SUCCESS', data: response })
  })
}

messageStore.dispatchToken = chatDispatcher.register(function (payload) {
  chatDispatcher.waitFor([conversationStore.dispatchToken])
  switch (payload.type) {
    case 'CONVERSATIONS_FETCH_SUCCESS':
    case 'CONVERSATIONS_REFETCH_SUCCESS':
    case 'CONVERSATIONS_FETCH_BY_JOB_SUCCESS':
    case 'CONVERSATIONS_FETCH_BY_QUERY_SUCCESS':
      if (conversationStore.getOpenConversationID() !== currentOpenConversationID) {
        messageStore.getAllForCurrentConversation()
      }
      break

    case 'FETCH_MESSAGES':
      loading = true
      messageStore.getAllForCurrentConversation()
      messageStore.emitChange()
      break

    case 'UPDATE_OPEN_CONVERSATION_ID':
      loading = true
      messageStore.getAllForCurrentConversation()
      messageStore.emitChange()
      break

    case 'MESSAGES_FETCH_SUCCESS':
      loading = false
      messages = payload.data.data.reverse()
      links = payload.data.links
      const openConversation = conversationStore.get(conversationStore.getOpenConversationID())
      unreadMessageCount = openConversation
        ? (openConversation.attributes[conversationStore.getPageContextType() + 'Unread'] || 0)
        : 0
      markAllAsRead()
      currentOpenConversationID = conversationStore.getOpenConversationID()
      messageStore.emitChange()
      break

    case 'MESSAGES_FETCH_NEXT':
      if (!loading && links.next) {
        loading = true
        scrollingMessages = true
        messageStore.fetchNext()
      } else {
        allMessagesLoaded = true
      }

      messageStore.emitChange()

      break

    case 'MESSAGES_FETCH_NEXT_SUCCESS':
      loading = false
      scrollingMessages = false
      const newMessages = payload.data.data || []
      messages = newMessages.reverse().concat(messages)
      links = payload.data.links
      markAllAsRead()
      currentOpenConversationID = conversationStore.getOpenConversationID()
      allMessagesLoaded = newMessages.length < 20
      messageStore.emitChange()
      break

    case 'CREATE_MESSAGE':
      const optimistic = buildOptimisticMessage({ messageBody: payload.data })
      createMessage({
        data: dataBuilder(payload.data, payload.aiGenerated),
        optimisticMessage: optimistic
      })
      messageStore.emitChange()
      break

    case 'CREATE_FILE_MESSAGE':
      // Match new logic in your app if you want to do file-by-file chaining
      const files = payload.data
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        const optimisticFile = buildOptimisticMessage({ spinner: true })
        const formData = new FormData()
        const apiData = dataBuilder(`Attachment: ${file.name}`)
        formData.append('file', file)
        formData.append('json_data', apiData)

        appendMessage(optimisticFile)
        $.ajax({
          url: window.App.url + '/messages',
          data: formData,
          method: 'POST',
          headers: ACCEPT,
          processData: false,
          contentType: false
        }).done((response) => {
          chatDispatcher.dispatch({
            type: 'MESSAGE_POST_SUCCESS',
            data: response.data,
            optimisticMessageID: optimisticFile.id
          })
        }).fail((response) => {
          const errorText = response.status === 500
            ? 'There was an error posting your message.'
            : response.responseJSON.errors[0].detail
          chatDispatcher.dispatch({
            type: 'MESSAGE_POST_FAIL',
            response,
            optimisticMessageID: optimisticFile.id,
            errorMessageText: errorText
          })
        }).always(() => {
          messageStore.emitChange()
        })
      }
      break

    case 'MESSAGE_POST_SUCCESS':
      replaceMessage({ id: payload.optimisticMessageID, replacementMessage: payload.data })
      conversationStore.fetch(conversationStore.getOpenConversationID())
      messageStore.emitChange()
      break

    case 'MESSAGE_POST_FAIL':
      const errorMessage = buildOptimisticMessage({
        messageBody: payload.errorMessageText,
        error: true
      })
      replaceMessage({ id: payload.optimisticMessageID, replacementMessage: errorMessage })
      messageStore.emitChange()
      break

    case 'NEW_MESSAGE_RECEIVED':
      appendMessage(payload.data.data)
      markAsRead(payload.data.data)
      messageStore.emitChange()
      break

    case 'MESSAGE_DELETED':
      messages = messages.map(m =>
        String(m.id) === String(payload.messageId)
          ? { ...m, attributes: { ...m.attributes, deleted: true } }
          : m
      )

      messageStore.emitChange()
      break

    default:
      return true
  }

  console.log('MessageStore: ', payload.type)
  return true
})

export default messageStore
